<template>
    <input type="text" v-model="name" placeholder="Enter your name" />
    <button @click="submitForm">Submit</button>
    <div style="color: red;">{{ responseMessage }}</div>
</template>
<script>
export default {
  name: 'FormPage',
  data() {
    return {
      name: '',
      responseMessage: ''
    };
  },
  methods: {
    async submitForm() {
      if (this.name) {
        //this.responseMessage = `Hello, ${this.name}! Your form has been submitted.`;

        const data = {
          name: this.name
        };

        try {
            const response = await fetch('https://spacepostest.up.railway.app/hello', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
            });

            const result = await response.json();
            this.responseMessage = result.message;
        } catch (error) {
            console.error(error);
            this.responseMessage = 'Error submitting form.';
        }

      } else {
        this.responseMessage = 'Please enter your name.';
      }
    }
  }
};
</script>